package ui.app.rss

import androidx.compose.runtime.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.compose.navigation.viewmodel.*
import tools.*

@VM
class AppRssListingVM : NavigationViewModel() {


    lateinit var selectedTab: MutableState<TabEntry<Node>>
        private set

    override fun onRelease() = Unit

    fun init(tabs: List<TabEntry<Node>>) {
        if (!::selectedTab.isInitialized) {
            selectedTab = mutableStateOf(tabs.first())
        }
    }

    fun selectTab(it: TabEntry<Node>) {
        if (!::selectedTab.isInitialized) {
            selectedTab = mutableStateOf(it)
        }
        if (selectedTab.value.tag != it.tag) {
            selectedTab.value = it
        }
    }
}
